export default __webpack_public_path__ + "static/homeMeta-5be41fc6266b850b9b39826753940b97.jpg";